import React from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import { DialogContent, DialogContentText } from '@mui/material';
import { dataProtectionModalStyles } from './blast-ai-chat-helper';

interface DataProtectionModalProps {
    onClose: Function;
    open: boolean;
}
export const DataProtectionModal = ({
    onClose,
    open = false,
}: DataProtectionModalProps): React.JSX.Element => {
    const handleClose = (): void => {
        onClose();
    };

    return (
        <Dialog
            closable
            open={open}
            title='Your Data Privacy'
            onClose={handleClose}
            sx={dataProtectionModalStyles.dialog}
        >
            <DialogContent sx={dataProtectionModalStyles.dialogBodyContainer}>
                <DialogContentText
                    style={dataProtectionModalStyles.dialogContentText}
                >
                    Your questions and my responses are private and
                    <br />
                    secure within BurstIQ&#39;s SOC 2 Type II LifeGraph
                    <br />
                    Platform. Your information is never shared publicly.
                </DialogContentText>
                <Button
                    sx={dataProtectionModalStyles.button}
                    size='large'
                    onClick={handleClose}
                    autoFocus
                >
                    OK
                </Button>
            </DialogContent>
        </Dialog>
    );
};
